<template>
  <div class="login-layout">
    <header class="login-layout__header">
      <auth-header-block>
        <router-link-to
          default_button
          :route_name="route_names.register">
          {{$t('auth.dont_have_account')}}
        </router-link-to>
      </auth-header-block>
    </header>
    <div class="login-layout__main">
      <div class="login-layout__main-inner">
        <h4>Sign In</h4>
        <gray-text class="mt-10">
          {{$t('auth.enter_your_email_and_password_to_sign_in')}}
        </gray-text>
        <hr class="my-30"/>
        <ValidationObserver v-slot="{ invalid, passes }" ref="form">
        <form class="d-flex flex-column"
              ref="form"
                      @submit.prevent="passes(submitForm)">
          <default-input
            name="email"
            type="test"
            placeholder="your@mail.com"
            :label="$t('inputs.email')"
            required
            v-model="email"
          />
          <default-input
            class="mt-10"
            :label="$t('inputs.password')"
            type="password"
            placeholder="Minimum 8 characters"
            required
            v-model="password"
          />
          <div
            class="text-end mt-15">
            <router-link-to
              class="fw-600"
              :route_name="route_names.forgot_password">
              {{ $t('auth.forgot_password') }}
            </router-link-to>
          </div>

          <info-block
            v-if="response_error"
            error
            class="mt-20">
            {{ response_error }}
          </info-block>
          <default-button
            class="mt-20">
            {{$t('auth.sign_in')}}
          </default-button>
        </form>
        </ValidationObserver>
      </div>
    </div>
    <loader v-if="loading"/>
  </div>
</template>

<script>

import GrayText from "../../small_components/GrayText.vue";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../../small_components/DefaultButton.vue";
import InfoBlock from "../../small_components/InfoBlock.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import {GO_TO_DASHBOARD, GO_TO_VERIFY_EMAIL} from "../../../router";
import {axiosAuth} from "../../../helpers/axios_requests";
import Loader from "../../small_components/Loader.vue";
import {mapActions, mapGetters} from "vuex";
import AuthHeaderBlock from "../../parts/AuthHeaderBlock.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import routes_mixin from "../../../mixins/routes_mixin";
import DefaultForm from "../../small_components/form-parts/DefaultForm.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../../store/modules/notifiocation";

export default {
  name: 'LoginLayout',
  mixins: [routes_mixin],
  components: {
    DefaultForm,
    RouterLinkTo,
    AuthHeaderBlock,
    Loader,
    DefaultInput,
    InfoBlock,
    DefaultButton,
    GrayText,
    ValidationObserver
  },
  computed: {
    ...mapGetters([
      'getUserMailVerified'
    ]),
  },
  data() {
    return {
      show_error: false,
      email: '',
      password: '',
      response_error: '',
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'actionSetUser',
      'actionSetUserToken',
      'actionChangeNotifications',
      'actionPushNotification'
    ]),
    submitForm() {
      this.loading = true
      this.response_error = ''
      axiosAuth.auth({
        email: this.email,
        password: this.password
      }).then(({data}) => {
        if (data.errors) {
          this.$refs.form.setErrors(data.errors);
          let message = FORMAT_ERROR_MESSAGE(data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.actionSetUser(data.user || null)
        this.actionSetUserToken(data.token || null)
        this.actionChangeNotifications()

        if (!data.user) return
        if (!this.getUserMailVerified) {
          return GO_TO_VERIFY_EMAIL()
        }
        if (this.$route.query && this.$route.query.from_page) {
          this.$router.push({path: decodeURIComponent(this.$route.query.from_page)})
        } else {
          GO_TO_DASHBOARD()
        }
      }).catch(e => {
        console.log(e);
        this.response_error = e.response?.data.error || e.response?.data.message
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
